import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/eduegoo/frontend/components/shared/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/eduegoo/frontend/components/shared/Header/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/eduegoo/frontend/node_modules/next/dist/client/link.js");
